import React from 'react';
import { IconProps } from '.';

const SvgMinusBold = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path fill={color} fillRule='evenodd' d='M21 13.5H3v-3h18v3Z' clipRule='evenodd' />
    </svg>
  );
};

export default SvgMinusBold;
